require("!!/home/vsts/work/1/s/emr-webapp/node_modules/script-loader/addScript.js")(require("!!/home/vsts/work/1/s/emr-webapp/node_modules/raw-loader/index.js!/home/vsts/work/1/s/emr-webapp/node_modules/source-map-loader/index.js!/home/vsts/work/1/s/emr-webapp/src/assets/js/socket.io.js"))


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/script-loader!/home/vsts/work/1/s/emr-webapp/src/assets/js/socket.io.js
// module id = ../../../../script-loader/index.js!../../../../../src/assets/js/socket.io.js
// module chunks = 3